import { render } from "./SalesforceLogsPage.vue?vue&type=template&id=453d263e&scoped=true"
import script from "./SalesforceLogsPage.vue?vue&type=script&lang=js"
export * from "./SalesforceLogsPage.vue?vue&type=script&lang=js"

import "./SalesforceLogsPage.vue?vue&type=style&index=0&id=453d263e&scoped=true&lang=css"

import exportComponent from "/Users/brianschroeter/Documents/Codex/2026-10-09/task/giving-dashboard-donor-fix/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-453d263e"]])

export default __exports__